/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PackageCard } from '@root/components/Package';
import Button from '@root/components/Button';
import useGiftCardRenewal from '@root/hooks/giftCard/useRenewal';
import './index.less';
import PageLoadError from '@root/components/PageLoadError';
import PageLoading from '@root/components/PageLoading';
import SafeAreaInset from '@root/components/SafeAreaInset';
import PayMethod from '../PayMethod';

// 实际上就是套餐续订，只是基本上这些套餐来自礼品卡

const GiftCardRenewal = () => {
  const { t } = useTranslation();
  const {
    state: { packageDetail, selectPriceId, loading, paying, payMethodState },
    action: { onSelected, onCreateRenewal, getPackage },
  } = useGiftCardRenewal();

  if (loading < 1) {
    return <PageLoading />;
  }

  if (loading === 2) {
    return <PageLoadError onTryAgain={getPackage} />;
  }

  return (
    <>
      <div className="flex-section-auto navbar-spacing">
        <PayMethod {...payMethodState}></PayMethod>
        <PackageCard
          key={packageDetail.goodsId}
          title={packageDetail.goodsName}
          priceList={packageDetail.goodsPriceList}
          checkedPriceId={selectPriceId}
          description={packageDetail.description}
          onSelected={onSelected}
          maxDevNum={packageDetail.maxDevNum}
          className="mt20"
          // className={selectPriceId.goodsId === item.goodsId ? 'active' : ''}
        />
      </div>
      <div className="flex-section-footer">
        <Button
          disabled={!selectPriceId}
          loading={paying}
          onClick={onCreateRenewal}
        >
          {t('purchase_now')}
        </Button>
        <SafeAreaInset />
      </div>
    </>
  );
};

export default GiftCardRenewal;
